var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Paginator',_vm._b({staticClass:"my-4",on:{"change-page":_vm.changePage}},'Paginator',_vm.properties,false))
}
var staticRenderFns = []

export { render, staticRenderFns }